import React from 'react';
import { Search, Filter } from 'lucide-react';

const ProjectFilters = ({ filters, onFilterChange }) => {
  return (
    <div className="flex flex-wrap items-center gap-3 mb-6">
      {/* Search Input */}
      <div className="relative flex-1 min-w-[200px]">
        <Search className="absolute left-2.5 top-1/2 transform -translate-y-1/2 text-[var(--text-secondary)]" size={16} />
        <input
          type="text"
          placeholder="Search projects or customers..."
          value={filters.searchTerm}
          onChange={(e) => onFilterChange('searchTerm', e.target.value)}
          className="w-full pl-9 pr-3 py-1.5 text-sm rounded-md border border-[var(--border-color)] bg-[var(--bg-secondary)] text-[var(--text-primary)] placeholder-[var(--text-secondary)]"
        />
      </div>

      {/* Status Filter */}
      <select
        value={filters.status}
        onChange={(e) => onFilterChange('status', e.target.value)}
        className="px-2 py-1.5 text-sm rounded-md border border-[var(--border-color)] bg-[var(--bg-secondary)] text-[var(--text-primary)]"
      >
        <option value="">Status: All</option>
        <option value="new">New</option>
        <option value="in_progress">In Progress</option>
        <option value="on_hold">On Hold</option>
        <option value="completed">Completed</option>
        <option value="cancelled">Cancelled</option>
      </select>

      {/* Type Filter */}
      <select
        value={filters.type}
        onChange={(e) => onFilterChange('type', e.target.value)}
        className="px-2 py-1.5 text-sm rounded-md border border-[var(--border-color)] bg-[var(--bg-secondary)] text-[var(--text-primary)]"
      >
        <option value="">Type: All</option>
        <option value="residential">Residential</option>
        <option value="commercial">Commercial</option>
        <option value="industrial">Industrial</option>
      </select>

      {/* Clear Filters Button */}
      {(filters.searchTerm || filters.status || filters.type) && (
        <button
          onClick={() => {
            onFilterChange('searchTerm', '');
            onFilterChange('status', '');
            onFilterChange('type', '');
          }}
          className="px-2 py-1.5 text-sm rounded-md border border-[var(--border-color)] text-[var(--text-secondary)] hover:text-[var(--text-primary)] hover:border-[var(--text-primary)] transition-colors inline-flex items-center gap-1"
        >
          <Filter size={14} />
          Clear
        </button>
      )}
    </div>
  );
};

export default ProjectFilters; 